import { render, staticRenderFns } from "./ChoreAssignModal.vue?vue&type=template&id=c397e976"
import script from "./ChoreAssignModal.vue?vue&type=script&lang=js"
export * from "./ChoreAssignModal.vue?vue&type=script&lang=js"
import style0 from "./ChoreAssignModal.vue?vue&type=style&index=0&id=c397e976&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports